export default "__VITE_ASSET__CmwuKgMq__";